/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/
import React from 'react';
import { Alert, Platform } from 'react-native'
import * as Updates from 'expo-updates';
import { Crashlytics } from '../firebase/config';

const promptForUpdate = () => {
 Alert.alert(
 "Update",
  "New Version Available! Select Update To Update Now.",
   [{
    text: "Update",
    onPress: async () => await Updates.reloadAsync(),
    style: "default",
    },
    {
    text: "Cancel",
    style: "cancel",
    },],
    {
    cancelable: true,
    }
    );
};


//Checks for OTA (Over-The-Air) app updates
const checkForUpdates = async (silent) => {
if (Platform.OS === 'web') {return;}
try {
const update = await Updates.checkForUpdateAsync();
if (update.isAvailable) {
const newUpdate = await Updates.fetchUpdateAsync();
if (newUpdate.isNew) {
promptForUpdate();
}
}
else {
if (!silent) {
alert("Empire Distributing is Up-To-Date!");
}
}
}
catch (e) {
console.error("Error fetching OTA Updates: ", e);
Crashlytics.recordError(e);
}
}


const OTAUpdates = {
promptForUpdate,
checkForUpdates
}
export default OTAUpdates